import { Component, Input } from '@angular/core';
import { Goal2030Model, OutcomeMetricModel, ProjectLinkedOutcomeModel, ProjectModel } from '../../../../../../hub_schema/hubTypes';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-goal-panel',
    templateUrl: './goal-panel.component.html',
    styleUrl: './goal-panel.component.scss',
    standalone: false
})
export class GoalPanelComponent {
    @Input()
    public project!: ProjectModel;

    @Input()
    public goal!: Goal2030Model;

    @Input()
    public outcomeMetrics: OutcomeMetricModel[];

    @Input()
    public projectLinkedOutcomes: ProjectLinkedOutcomeModel[];

    public getGoalClass(goalName: string): string {
        if (goalName === 'Climate Mitigation') {
            return 'climate-mitigation';
        } else if (goalName === 'Climate Adaptation') {
            return 'climate-adaptation';
        } else if (goalName === 'Healthy Oceans') {
            return 'healthy-oceans';
        } else if (goalName === 'Healthy Lands') {
            return 'healthy-lands';
        } else if (goalName === 'Healthy Freshwater') {
            return 'healthy-freshwater';
        } else if (goalName === 'People') {
            return 'people';
        }
        return '';
    }

    public isExpanded: boolean = false;

    public expandCloseGoal() {
        this.isExpanded = !this.isExpanded;
    }

    public getTargets() {
        let targets = this.project.projectGoalTargets.find(pgt => {
            return pgt.goalId === this.goal.goal2030Id;
        });

        var target;

        if (!!targets) {
            target = targets.targetValue;
        }
        return target;
    }

    public calculateProgress() {
        const outcomeIdsInGroup = this.projectLinkedOutcomes.map(lo => lo.projectOutcome.outcome.outcomeId);
        var filteredLinkedOutcomes = this.projectLinkedOutcomes.filter(
            a =>
                !a.projectOutcome.outcome?.parentOutcomes.some(
                    po => outcomeIdsInGroup.some(id => id === po.outcomeId) && outcomeIdsInGroup.some(id => id === po.parentOutcomeId)
                )
        );

        var progressTotal = filteredLinkedOutcomes.reduce((acc, currentVal) => {
            let progress = currentVal.projectOutcome.outcomeStatistics.totalProgress;
            if (currentVal.projectOutcome.outcome.outcomeUnit?.outcomeUnitId !== currentVal.projectOutcome.outcome.outcomeMetric.preferredUnitId) {
                var unitConversion = currentVal.projectOutcome.outcome.outcomeUnit.unitConversions.find(
                    ouc =>
                        ouc.sourceUnitId === currentVal.projectOutcome.outcome.outcomeMetric.preferredUnitId &&
                        ouc.targetUnitId === currentVal.projectOutcome.outcome.outcomeUnit?.outcomeUnitId
                );
                progress = progress / unitConversion.conversion;
            }

            return acc + progress;
        }, 0);
        return progressTotal;
    }

    public calculateProgressPercentage() {
        var gt = this.getTargets();
        return gt !== 0 ? (this.calculateProgress() / gt) * 100 : 0;
    }

    public calculateTargetPercentageRemaining() {
        var cpp = this.calculateProgressPercentage();

        return cpp > 0 ? 100 - this.calculateProgressPercentage() : 100;
    }

    public getOutcomeTargetUnit() {
        let targets = this.project.projectGoalTargets.find(pgt => {
            return pgt.goalId === this.goal.goal2030Id;
        });

        return this.outcomeMetrics?.find(om => om?.goal2030Id == targets?.goalId)?.preferredUnit?.name;
    }

    public displayPreferredOutcomeMetricName() {
        return this.outcomeMetrics.find(om => {
            return this.goal.goal2030Id === om.goal2030.goal2030Id;
        })?.preferredUnit?.name;
    }

    public get linkedOutcomes(): any[] {
        if (this.project) {
            return this.project.linkedOutcomes;
        }
        return [];
    }
}
